export const color = {
  PRIMARY: '#6246ea',
}
